export default store => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
    store.commit('browser/updateIsIE', true);
    document.body.classList.add('isIE');
  }
};
